import { ShareResourceModal } from '@backrs_ui/grow-ui/src/components/ShareResourceModal/ShareResourceModal';
import { sessionNames } from '@backrs_ui/grow-ui/src/components/SolutionSession/SessionStrings';
import { SolutionSessionId } from '@backrs_ui/grow-ui/src/models/models';

type ShareSolutionSessionModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
  sessionId: number;
  sessionType: SolutionSessionId;
}>;

export const ShareSolutionSessionModal = ({
  open,
  onClose,
  sessionId,
  sessionType,
}: ShareSolutionSessionModalProps) => {
  const sessionName = sessionNames[sessionType] || 'Session';

  return (
    <ShareResourceModal
      open={open}
      onClose={onClose}
      resourceType="solution_session"
      resourceId={sessionId}
      sharePath={`/solution-session/${sessionType}`}
      resourceName={sessionName}
    />
  );
};
